<div class="main-content strpt-report-page" [class.strpt-report-page--embed]="embedInDashboard">
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="card strpt-report-card" [class.strpt-report-card--embed]="embedInDashboard">
					<div class="card-header card-header-{{ globalSearchService.color }}-6" *ngIf="!embedInDashboard">
						<h4 class="card-title">
							<i class="material-icons strpt-report-back" (click)="back()">arrow_back</i>
							Salesman Territory Report (STRPT)
						</h4>
						<p class="card-category text-right mb-0">Sales by territory, customer, and selected brands</p>
					</div>
					<div class="card-body" [class.strpt-report-card__body--embed]="embedInDashboard">
						<section class="strpt-filters" aria-label="Report filters">
							<div class="strpt-filters__head">
								<span class="strpt-filters__title">Filters</span>
								<span class="strpt-filters__hint">Set criteria, then run the report</span>
							</div>
							<form (ngSubmit)="$event.preventDefault(); runReport()">
								<div class="row g-3">
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 strpt-field">
											<mat-label>Date range</mat-label>
											<mat-select [formControl]="dateRangeCtrl">
												<mat-option *ngFor="let o of dateRangeOptions" [value]="o.value">{{ o.label }}</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-8" *ngIf="dateRangeCtrl.value === 'Custom'">
										<mat-form-field appearance="outline" class="w-100 strpt-field">
											<mat-label>Custom dates</mat-label>
											<mat-date-range-input [rangePicker]="strptPicker">
												<input matStartDate [formControl]="fromDateCtrl" placeholder="Start" />
												<input matEndDate [formControl]="toDateCtrl" placeholder="End" />
											</mat-date-range-input>
											<mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
											<mat-datepicker-toggle matSuffix [for]="strptPicker"></mat-datepicker-toggle>
											<mat-date-range-picker #strptPicker></mat-date-range-picker>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 strpt-field">
											<mat-label>Salespeople</mat-label>
											<mat-select [formControl]="salesmanCtrl" multiple disableOptionCentering appSelectAll>
												<mat-select-trigger>{{ salesmanTriggerLabel }}</mat-select-trigger>
												<mat-option *ngFor="let sp of salespeople" [value]="sp.salesmancode">
													{{ sp.salesmancode }} — {{ sp.salesmanname }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 strpt-field">
											<mat-label>Branches</mat-label>
											<mat-select [formControl]="loccodeCtrl" multiple disableOptionCentering appSelectAll>
												<mat-select-trigger>{{ branchTriggerLabel }}</mat-select-trigger>
												<mat-option *ngFor="let l of locations" [value]="l.loccode">{{ l.locationname }}</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field appearance="outline" class="w-100 strpt-field">
											<mat-label>Territory</mat-label>
											<mat-select [formControl]="territoryCtrl">
												<mat-option value="All">All territories</mat-option>
												<mat-option *ngFor="let t of territories" [value]="t.territory_id">{{ t.territory_name }}</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-12">
										<mat-form-field appearance="outline" class="w-100 strpt-field strpt-field--brands">
											<mat-label>Brands</mat-label>
											<mat-select [formControl]="brandsCtrl" multiple disableOptionCentering appSelectAll>
												<mat-select-trigger>{{ brandTriggerLabel }}</mat-select-trigger>
												<mat-option *ngFor="let b of brandsMeta" [value]="b.manufacturer_id">{{
													b.name || '#' + b.manufacturer_id
												}}</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
								</div>
								<div class="strpt-actions">
									<button
										mat-raised-button
										color="accent"
										type="submit"
										class="strpt-actions__primary"
										[disabled]="sending || !(brandsCtrl.value?.length)"
									>
										<mat-icon>search</mat-icon>
										Run report
									</button>
									<span *ngIf="sending" class="strpt-actions__spinner">
										<mat-spinner diameter="36"></mat-spinner>
									</span>
									<div class="strpt-actions__exports" *ngIf="hasTableData">
										<button
											type="button"
											class="btn btn-success btn-sm strpt-export"
											(click)="$event.preventDefault(); exportXls()"
											matTooltip="Export XLSX"
										>
											<i class="fa fa-file-excel-o"></i> XLS
										</button>
										<button
											type="button"
											class="btn btn-danger btn-sm strpt-export"
											(click)="$event.preventDefault(); exportPdf()"
											matTooltip="Export PDF"
										>
											<i class="fa fa-file-pdf-o"></i> PDF
										</button>
									</div>
								</div>
							</form>
						</section>

						<section class="strpt-results" *ngIf="reportCriteria && grandTotals">
							<div class="strpt-results__heading">
								<h3 class="strpt-results__title">
									Salesman territory
									<span class="strpt-results__dates" *ngIf="reportCriteria.datefrom && reportCriteria.dateto">
										{{ reportCriteria.datefrom | date : 'MM/dd/yy' }} – {{ reportCriteria.dateto | date : 'MM/dd/yy' }}
									</span>
								</h3>
								<p class="strpt-results__subtitle" *ngIf="getSubtitle()">{{ getSubtitle() }}</p>
							</div>

							<div class="strpt-kpi-grid" role="group" aria-label="Report summary">
								<div class="strpt-kpi">
									<span class="strpt-kpi__label">Territories</span>
									<span class="strpt-kpi__value">{{ territoryBlocks.length | number : '1.0-0' }}</span>
								</div>
								<div class="strpt-kpi">
									<span class="strpt-kpi__label">Customer rows</span>
									<span class="strpt-kpi__value">{{ totalDataRows | number : '1.0-0' }}</span>
								</div>
								<div class="strpt-kpi strpt-kpi--featured">
									<span class="strpt-kpi__label">Grand total</span>
									<span class="strpt-kpi__value strpt-kpi__value--money">{{ grandTotals.lineTotal | currency }}</span>
								</div>
							</div>
						</section>

						<div class="strpt-table-panel" *ngIf="hasTableData">
							<div class="strpt-table-panel__bar">
								<span class="strpt-table-panel__label">Territory breakdown</span>
								<span class="strpt-table-panel__meta">
									{{ totalDataRows | number }} rows · {{ territoryBlocks.length | number }}
									{{ territoryBlocks.length === 1 ? 'territory' : 'territories' }}
								</span>
							</div>
							<div class="strpt-table-wrap">
								<table class="strpt-table">
									<thead>
										<tr>
											<th class="strpt-th strpt-th--lead">Territory</th>
											<th class="strpt-th strpt-th--num">Cust #</th>
											<th class="strpt-th strpt-th--name">Customer</th>
											<th *ngFor="let c of brandColumns" class="strpt-th strpt-th--num">{{ c.label }}</th>
											<th class="strpt-th strpt-th--num">OTHER</th>
											<th class="strpt-th strpt-th--num">Total</th>
										</tr>
									</thead>
									<tbody>
										<ng-container *ngFor="let block of territoryBlocks">
											<tr class="strpt-territory-row">
												<td [attr.colspan]="3 + brandColumns.length + 2" class="strpt-territory-title">
													{{ block.territoryName }}
												</td>
											</tr>
											<tr
												*ngFor="let row of block.rows; let ri = index"
												class="strpt-data-row"
												[class.strpt-data-row--alt]="ri % 2 === 1"
											>
												<td class="strpt-cell strpt-cell--muted"></td>
												<td class="strpt-cell strpt-cell--num text-nowrap">{{ row.debtorno }}</td>
												<td class="strpt-cell strpt-cell--name" [matTooltip]="row.name">{{ row.name }}</td>
												<td *ngFor="let v of row.brands" class="strpt-cell strpt-cell--num">{{ v | currency }}</td>
												<td class="strpt-cell strpt-cell--num">{{ row.other | currency }}</td>
												<td class="strpt-cell strpt-cell--num strpt-cell--strong">{{ row.lineTotal | currency }}</td>
											</tr>
											<tr class="strpt-subtotal-row">
												<td class="strpt-cell"></td>
												<td class="strpt-cell strpt-cell--sub-label" colspan="2">Subtotal</td>
												<td *ngFor="let v of block.subtotals.brands" class="strpt-cell strpt-cell--num strpt-cell--sub">
													{{ v | currency }}
												</td>
												<td class="strpt-cell strpt-cell--num strpt-cell--sub">{{ block.subtotals.other | currency }}</td>
												<td class="strpt-cell strpt-cell--num strpt-cell--sub">{{ block.subtotals.lineTotal | currency }}</td>
											</tr>
										</ng-container>
										<tr class="strpt-grand-row" *ngIf="grandTotals">
											<td class="strpt-cell"></td>
											<td class="strpt-cell strpt-cell--grand-label" colspan="2">Grand total</td>
											<td *ngFor="let v of grandTotals.brands" class="strpt-cell strpt-cell--num strpt-cell--grand">
												{{ v | currency }}
											</td>
											<td class="strpt-cell strpt-cell--num strpt-cell--grand">{{ grandTotals.other | currency }}</td>
											<td class="strpt-cell strpt-cell--num strpt-cell--grand">{{ grandTotals.lineTotal | currency }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>

						<div *ngIf="metaLoaded && !sending && showEmptyAfterRun" class="strpt-empty">
							<mat-icon>search_off</mat-icon>
							<p>No sales matched the selected criteria.</p>
							<span class="strpt-empty__hint">Try a wider date range, another territory, or fewer filters.</span>
						</div>

						<p class="strpt-placeholder text-muted" *ngIf="metaLoaded && !reportCriteria && !sending">
							Set filters above and run the report to load territory sales.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
